




















































import Vue from 'vue'
import PopupSecondQuiz from '@/views/templates/kuntama/PopupSecondQuiz.vue'
import ReshowQuiz from '@/views/atoms/ReshowQuiz'
import Scope from '@/views/atoms/Scope.vue'
import ScrollFire from '@/views/mixin/ScrollFire'
import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import PopupCircleEpisode from '@/views/templates/kuntama/PopupCircleEpisode.vue'

Vue.mixin(ScrollFire)

export default
  components: {
    Scope
    EpisodeTitle
    ReshowQuiz
    PopupSecondQuiz
    PopupCircleEpisode
  }

  data: () ->
    fire_scroll: true
    targetID: -1
    showQuiz: 0
    isSuccess: false
    title_image: [
      '/assets/image/kuntama/episode6_title01.png'
      '/assets/image/kuntama/episode6_title02.png'
      '/assets/image/kuntama/episode6_title03.png'
      '/assets/image/kuntama/episode6_title04.png'
      '/assets/image/kuntama/episode6_title05.png'
      '/assets/image/kuntama/episode6_title06.png'
    ]
    subtitle: [
      [
        'だしの中で2日間'
      ]
      [
        '水にさらした後はしっかり乾燥'
      ]
      [
        '3日目に燻製窯へ'
      ]
      [
        '低温の煙でじっくりと'
      ]
      [
        '出来栄えを左右する網棚の段替え'
      ]
      [
        'つややかに色付いた燻製たまご'
      ]
    ]
    message: [
      [
        'だしが入った熱々の石窯に契約農家から仕入れた新鮮たまごと北海道産昆布を一緒に入れて一晩漬け込みます。翌日煮たら、さらに一晩寝かせます。'
        'ゆっくり温度を下げることで、だしの旨みを黄身まで染み込ませます。'
      ]
      [
        '2日間だしに漬けたたまごを水にさらし、ひとつずつ検品しながら殻に付いた水分を拭き取ります。'
        '殻の表面に水分が付いていると煙の成分と反応し、酸味やえぐみ、苦みが出てしまうため、丁寧に拭き上げて十分に乾燥させます。'
      ]
      [
        '燻製窯の中全体に煙がまわりやすよう四隅は空けながら、たまごを網棚に並べます。'
        '窯の中で新鮮な煙を循環させることにより、煙特有のえぐみや苦味、酸味が軽減されます。'
      ]
      [
        '一度くべたチップは12時間しか持たないので、朝5時と夕方5時の一日2回チップをくべて、燻製窯の温度を45～50℃に保ちます。'
      ]
      [
        '燻製窯にたまごを入れてから3日目に検卵と段替えを行います。窯や網棚を置く段の特性によって燻製度合いが異なるため、ひとつずつ状態を確認しながら、たまごの位置を調整します。'
      ]
      [
        '殻のまま、6日間かけてじっくり燻されたたまごはつややかに色付きます。その後、静かに休ませて熟成を進めることで、煙の風味が黄身の深部まで染みわたります。'
      ]
    ]
    images: [
      '/assets/image/kuntama/episode6_popup_01.png'
      '/assets/image/kuntama/episode6_popup_02.png'
      '/assets/image/kuntama/episode6_popup_03.png'
      '/assets/image/kuntama/episode6_popup_04.png'
      '/assets/image/kuntama/episode6_popup_05.png'
      '/assets/image/kuntama/episode6_popup_06.png'
    ]
    points: [
      'p4-8'
      'p4-9'
      'p4-10'
      'p4-11'
      'p4-12'
      'p4-13'
    ]

  created: () ->
    @$options.scroll_target = '.episode6'

  mounted: () ->
    @scrollSticky()

  methods: {
    showPopup: (target) ->
      @targetID = target
      @$emit('showdPopup', true)
    closePopup: () ->
      @targetID = -1
      @$emit('showdPopup', false)
    reshow_quiz: () ->
      @showQuiz = 1
      @$emit('showdPopup', true)
    closeQuiz: () ->
      if @isSuccess
        @showQuiz = 3
      else
        @showQuiz = 2
      @$emit('showdPopup', false)
    addPoint: (point) ->
      @$emit('addPoint', point)
    success: ()  ->
      @isSuccess = true
    scrollFire: () ->
      if @showQuiz == 0
        @showQuiz = 1
      @scrollSticky()
    scrollSticky: () ->
      top = document.querySelector('.space01').offsetTop + document.querySelector('.space01').offsetHeight
      left = (window.scrollY - top)

      if left < 0
        left = 0
      document.querySelector('.episode6 .row_line .row_block').style.marginLeft = (-left) + 'px'
  }
